export function viewTrajectoryRoute(root: string) {
  return () => {
    return `${root}/view/:trajectoryId/:trajectoryVisualisation`;
  };
}
